var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M17.971 21a1.044 1.044 0 011.006 1.325A17.28 17.28 0 0018.323 27c0 1.558.218 3.116.654 4.675A1.044 1.044 0 0117.97 33a1.92 1.92 0 01-1.858-1.44 18.221 18.221 0 01-.587-4.56c0-1.52.195-3.04.587-4.56A1.92 1.92 0 0117.97 21zM24 15.247c1.485-.602 2.126.917 2.563 2.519l.088.331c.293 1.143.18 2.255-.338 3.334 3.756-.123 5.976.062 6.662.555.543.391 1.498.942.75 3.37-.75 2.428-.439 1.481-1.482 4.25-.37.98-.696 1.748-.981 2.305A2 2 0 0129.482 33h-7.08a2 2 0 01-1.91-1.407c-.46-1.48-.69-2.979-.69-4.498 0-1.679.244-3.146.732-4.403a2 2 0 01.737-.93l.15-.11c.401-.317.807-.816 1.218-1.495.43-.712.684-1.77.684-2.652 0-.883-.162-1.918.677-2.258z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
